import React from 'react'
import { motion } from 'framer-motion'

const fade = (d) => ({
  initial:    { opacity: 0, y: 20 },
  animate:    { opacity: 1, y: 0 },
  transition: { duration: 0.9, delay: d, ease: [0.22, 1, 0.36, 1] },
})

export default function Hero({ post }) {
  return (
    <div className="sp-hero">
      <div className="sp-hero__img-wrap">
        {post.thumb
          ? <img src={post.thumb} alt={post.title} className="sp-hero__img" />
          : <div className="sp-hero__img-fallback" />
        }
        <div className="sp-hero__vignette" />
      </div>

      <div className="sp-hero__content">
        {post.category && (
          <motion.span className="sp-hero__cat" {...fade(0.15)}>
            {post.category}
          </motion.span>
        )}
        <motion.h1 className="sp-hero__title" {...fade(0.28)} dangerouslySetInnerHTML={{ __html: post.title }} />
        <motion.div className="sp-hero__meta" {...fade(0.42)}>
          {post.date && <span>{post.date}</span>}
        </motion.div>
      </div>
    </div>
  )
}
